(function () {
  'use strict';

  var root = document.querySelector('[data-palmr-cart-drawer]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var isLoading = false;
  var lastFocus = null;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function moneyFormat(cents) {
    var dollars = Math.max(0, cents / 100);
    if (dollars === Math.floor(dollars)) return '$' + dollars.toFixed(0);
    return '$' + dollars.toFixed(2);
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = $('.palmr-cd__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('palmr:cart-drawer:opened'));
    loadRecommendations();
    getCart().then(function (cart) {
      renderDiscountStatus(cart);
      loadBundleUpsells(cart);
      loadVolumeBundleProgress(cart);
      fetchShippingEstimate(cart);
      if (cart.item_count > 0) klaviyoTrack('Viewed Cart', buildCartPayload(cart));
    }).catch(function () {});
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('palmr:cart-drawer:closed'));
  }

  function setLoading(loading) {
    isLoading = loading;
    root.classList.toggle('is-loading', loading);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  /* ---------- Klaviyo tracking ---------- */
  function klaviyoEnabled() {
    return root.getAttribute('data-klaviyo-enable') === 'true';
  }
  function klaviyoTrack(event, payload) {
    if (!klaviyoEnabled()) return;
    try {
      window._learnq = window._learnq || [];
      var email = root.getAttribute('data-customer-email');
      if (email) {
        window._learnq.push(['identify', { '$email': email }]);
      }
      window._learnq.push(['track', event, payload]);
    } catch (e) {}
  }
  function buildCartPayload(cart, addedItem) {
    var items = (cart.items || []).map(function (i) {
      return {
        ProductID: i.product_id,
        SKU: i.sku,
        ProductName: i.product_title,
        Quantity: i.quantity,
        ItemPrice: i.price / 100,
        RowTotal: i.line_price / 100,
        ProductURL: location.origin + i.url,
        ImageURL: i.image,
        ProductCategories: i.product_type ? [i.product_type] : []
      };
    });
    var payload = {
      $value: cart.total_price / 100,
      ItemNames: items.map(function (i) { return i.ProductName; }),
      CheckoutURL: location.origin + '/cart',
      Items: items
    };
    if (addedItem) {
      payload.AddedItemProductName = addedItem.product_title || addedItem.title;
      payload.AddedItemProductID = addedItem.product_id || addedItem.id;
      payload.AddedItemSKU = addedItem.sku;
      payload.AddedItemPrice = (addedItem.price || 0) / 100;
      payload.AddedItemQuantity = addedItem.quantity || 1;
      payload.AddedItemImageURL = addedItem.image;
      payload.AddedItemProductCategories = addedItem.product_type ? [addedItem.product_type] : [];
      payload.AddedItemURL = addedItem.url ? (location.origin + addedItem.url) : '';
    }
    return payload;
  }

  function refresh() {
    setLoading(true);
    return fetch('/?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-palmr-cart-drawer]');
        if (!fresh) return;

        var bodyNew = fresh.querySelector('[data-palmr-cd-body]');
        var footerNew = fresh.querySelector('[data-palmr-cd-footer]');
        var rewardNew = fresh.querySelector('[data-palmr-cd-reward]');
        var countNew = fresh.querySelector('[data-palmr-cd-count]');

        if (bodyNew) $('[data-palmr-cd-body]').innerHTML = bodyNew.innerHTML;
        if (footerNew) {
          var footer = $('[data-palmr-cd-footer]');
          footer.innerHTML = footerNew.innerHTML;
          if (footerNew.hasAttribute('hidden')) footer.setAttribute('hidden', '');
          else footer.removeAttribute('hidden');
        }
        if (countNew && $('[data-palmr-cd-count]')) {
          $('[data-palmr-cd-count]').textContent = countNew.textContent;
        }
        if (rewardNew && $('[data-palmr-cd-reward]')) {
          $('[data-palmr-cd-reward]').replaceWith(rewardNew);
        }
        updateRewardBar();
        getCart().then(function (cart) {
          renderDiscountStatus(cart);
          updateGiftPickers(cart);
          loadBundleUpsells(cart);
          loadVolumeBundleProgress(cart);
          fetchShippingEstimate(cart);
        }).catch(function () {});
        if (root.classList.contains('is-open')) loadRecommendations();
      })
      .catch(function (err) { console.warn('[palmr-cd] refresh failed', err); })
      .finally(function () { setLoading(false); });
  }

  /* ---------- Free gift system ---------- */
  // Qualifying total uses final_line_price (post-discount) so applied codes
  // "cost" gift progress — customer must spend more to reach a tier after a code.
  function getGiftState(cart) {
    var giftLines = { '1': [], '2': [] };
    var qualifyingTotal = 0;
    (cart.items || []).forEach(function (item) {
      var tier = item.properties && item.properties._gift_tier;
      var lineFinal = (item.final_line_price != null) ? item.final_line_price
                    : (item.line_price != null) ? item.line_price
                    : (item.price * item.quantity);
      var lineOriginal = item.original_line_price || (item.original_price * item.quantity);
      if (tier && giftLines[String(tier)]) {
        giftLines[String(tier)].push({ key: item.key, qty: item.quantity, price: lineOriginal });
      } else {
        qualifyingTotal += lineFinal;
      }
    });
    return { lines: giftLines, qualifyingTotal: qualifyingTotal };
  }

  function isGiftDismissed(tier) {
    try { return sessionStorage.getItem('palmr_gift_dismissed_' + tier) === '1'; }
    catch (e) { return false; }
  }
  function setGiftDismissed(tier, dismissed) {
    try {
      if (dismissed) sessionStorage.setItem('palmr_gift_dismissed_' + tier, '1');
      else sessionStorage.removeItem('palmr_gift_dismissed_' + tier);
    } catch (e) {}
  }

  // Bundle upsell dismissal — localStorage (persists across sessions). If a
  // shopper says "no thanks" we should remember it next visit, not nag them.
  var BUNDLE_DISMISS_KEY = 'palmr_bundle_dismissed_v1';
  function getDismissedBundleIds() {
    try {
      var raw = localStorage.getItem(BUNDLE_DISMISS_KEY);
      if (!raw) return {};
      var obj = JSON.parse(raw);
      return obj && typeof obj === 'object' ? obj : {};
    } catch (e) { return {}; }
  }
  function setBundleDismissed(bundleId) {
    if (!bundleId) return;
    try {
      var current = getDismissedBundleIds();
      current[bundleId] = Date.now();
      localStorage.setItem(BUNDLE_DISMISS_KEY, JSON.stringify(current));
    } catch (e) {}
  }

  function updateGiftPickers(cart) {
    var state = getGiftState(cart);
    ['1', '2'].forEach(function (tier) {
      var picker = $('[data-palmr-cd-gift-picker="' + tier + '"]');
      if (!picker) return;
      var threshold = parseInt(picker.getAttribute('data-threshold'), 10);
      var qualifies = state.qualifyingTotal >= threshold;
      var hasGift = state.lines[tier].length > 0;
      if (qualifies && !hasGift) {
        picker.removeAttribute('hidden');
        if (isGiftDismissed(tier)) picker.classList.add('is-collapsed');
        else picker.classList.remove('is-collapsed');
      } else {
        picker.setAttribute('hidden', '');
        picker.classList.remove('is-collapsed');
      }
      if (!qualifies && hasGift) {
        state.lines[tier].forEach(function (g) { silentRemoveLine(g.key); });
      }
      if (hasGift) setGiftDismissed(tier, false);
    });
  }

  function silentRemoveLine(key) {
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { return refresh(); }).catch(function () {});
  }

  function pickGift(tier, variantId) {
    if (!variantId || isLoading) return Promise.resolve();
    setLoading(true);
    return getCart().then(function (cart) {
      var existing = (cart.items || []).filter(function (i) {
        var t = i.properties && i.properties._gift_tier;
        return String(t) === String(tier);
      });
      var removals = existing.map(function (i) {
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: i.key, quantity: 0 })
        });
      });
      return Promise.all(removals);
    }).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { '_gift_tier': String(tier) }
        })
      });
    }).then(function (res) { return res.json(); })
      .then(function () { return refresh(); })
      .catch(function (err) {
        console.warn('[palmr-cd] gift pick failed', err);
        setLoading(false);
      });
  }

  function updateRewardBar() {
    var reward = $('[data-palmr-cd-reward]');
    if (!reward) return;
    var shipping = parseInt(reward.getAttribute('data-shipping'), 10) || 0;
    var tier1 = parseInt(reward.getAttribute('data-tier1'), 10) || 0;
    var tier2 = parseInt(reward.getAttribute('data-tier2'), 10) || 0;
    var hasShipping = shipping > 0;
    var hasTier2 = tier2 > 0;
    if (!tier1) return;

    // Build ordered list of enabled tiers; assign positions tuned to reflect
    // typical dollar-gap reality (small gap shipping→tier1, larger gap tier1→tier2)
    // 1 tier → [92], 2 → [50,92], 3 → [30,55,92]
    var tiers = [];
    if (hasShipping) tiers.push({ key: 'shipping', amount: shipping });
    tiers.push({ key: '1', amount: tier1 });
    if (hasTier2) tiers.push({ key: '2', amount: tier2 });
    var positions;
    if (tiers.length === 1) positions = [92];
    else if (tiers.length === 2) positions = [50, 92];
    else positions = [30, 55, 92];
    tiers.forEach(function (t, i) { t.position = positions[i]; });

    getCart().then(function (cart) {
      // Qualifying total = sum of POST-DISCOUNT non-gift line prices. Codes reduce
      // gift progress; customer must spend more to hit a tier after applying one.
      var total = 0;
      (cart.items || []).forEach(function (i) {
        if (i.properties && i.properties._gift_tier) return;
        var f = (i.final_line_price != null) ? i.final_line_price
              : (i.line_price != null) ? i.line_price
              : (i.price * i.quantity);
        total += f;
      });

      // Piecewise-linear fill: each segment maps linearly between its tier positions.
      // Before first tier: 0 → tiers[0].position. After last: tiers[last].position → 100.
      var pct = 0;
      if (total <= 0) {
        pct = 0;
      } else if (total >= tiers[tiers.length - 1].amount) {
        pct = 100;
      } else {
        for (var idx = 0; idx < tiers.length; idx++) {
          if (total < tiers[idx].amount) {
            var prevPos = idx === 0 ? 0 : tiers[idx - 1].position;
            var prevAmt = idx === 0 ? 0 : tiers[idx - 1].amount;
            var span = tiers[idx].position - prevPos;
            var amtSpan = tiers[idx].amount - prevAmt;
            pct = prevPos + ((total - prevAmt) / amtSpan) * span;
            break;
          }
        }
      }
      var fill = $('[data-palmr-cd-reward-fill]');
      var msg = $('[data-palmr-cd-reward-message]');
      if (fill) fill.style.width = Math.round(pct) + '%';

      // Position markers + achievement state
      tiers.forEach(function (t) {
        var marker = $('[data-palmr-cd-reward-marker="' + t.key + '"]');
        if (!marker) return;
        marker.style.left = t.position + '%';
        marker.setAttribute('data-state', total >= t.amount ? 'achieved' : 'pending');
      });

      if (!msg) return;

      // Find the next pending tier (first tier whose amount > total)
      var nextIdx = -1;
      for (var ni = 0; ni < tiers.length; ni++) {
        if (total < tiers[ni].amount) { nextIdx = ni; break; }
      }

      var template = '';
      if (nextIdx === -1) {
        // All tiers achieved
        template = hasTier2
          ? (reward.getAttribute('data-all-achieved') || '')
          : (reward.getAttribute('data-tier1-achieved') || '');
        msg.textContent = template;
      } else {
        var nextTier = tiers[nextIdx];
        var prevTier = nextIdx > 0 ? tiers[nextIdx - 1] : null;
        var amountNeeded = nextTier.amount - total;

        if (nextTier.key === 'shipping') {
          template = reward.getAttribute('data-shipping-pending') || '';
        } else if (nextTier.key === '1') {
          if (prevTier && prevTier.key === 'shipping') {
            template = reward.getAttribute('data-shipping-to-gift') || reward.getAttribute('data-tier1-pending') || '';
          } else {
            template = reward.getAttribute('data-tier1-pending') || '';
          }
        } else if (nextTier.key === '2') {
          template = reward.getAttribute('data-tier1-achieved') || reward.getAttribute('data-tier2-pending') || '';
        }

        msg.textContent = template.replace('{{amount}}', moneyFormat(amountNeeded));
      }
    }).catch(function () {});
  }

  /* ---------- Recommendations ---------- */
  var recsLoadedForProduct = null;
  var KIDS_RE = /\b(kid|kids|boy|boys|girl|girls|youth|child|children|toddler|baby|infant)\b/i;
  var ADULTS_RE = /\b(men|mens|women|womens|adult|adults|unisex)\b/i;

  function detectCartCategory(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return 'mixed';
    var k = 0, a = 0;
    cart.items.forEach(function (item) {
      var text = ((item.product_title || '') + ' ' + (item.url || '') + ' ' + (item.product_type || '')).toLowerCase();
      if (KIDS_RE.test(text)) k++;
      else if (ADULTS_RE.test(text)) a++;
    });
    var total = cart.items.length;
    if (k / total > 0.6) return 'kids';
    if (a / total > 0.6) return 'adults';
    return 'mixed';
  }

  function updateRecsTitle(cart) {
    var titleEl = $('.palmr-cd__recs-title');
    if (!titleEl) return;
    if (!titleEl.hasAttribute('data-base-title')) titleEl.setAttribute('data-base-title', titleEl.textContent);
    if (root.getAttribute('data-smart-title') !== 'true') return;
    var category = detectCartCategory(cart);
    var kidsTitle = root.getAttribute('data-smart-title-kids');
    var adultsTitle = root.getAttribute('data-smart-title-adults');
    var base = titleEl.getAttribute('data-base-title');
    if (category === 'kids' && kidsTitle) titleEl.textContent = kidsTitle;
    else if (category === 'adults' && adultsTitle) titleEl.textContent = adultsTitle;
    else titleEl.textContent = base;
  }

  /* ---------- Bundle upsells (Complete the Look) ---------- */
  function getBundleIndex() {
    try {
      var el = document.getElementById('palmr-bundles-index');
      if (!el) return null;
      var raw = el.textContent.trim();
      if (!raw) return null;
      var idx = JSON.parse(raw);
      if (!idx || !Array.isArray(idx.bundles)) return null;
      return idx;
    } catch (e) { return null; }
  }

  function cartHasHandle(cart, handle) {
    return (cart.items || []).some(function (i) { return i.handle === handle; });
  }

  function loadBundleUpsells(cart) {
    var container = $('[data-palmr-cd-upsells]');
    if (!container) return;
    var list = $('[data-palmr-cd-upsells-list]', container);
    if (!list) return;

    var index = getBundleIndex();
    if (!index) { container.setAttribute('hidden', ''); list.innerHTML = ''; return; }

    var dismissed = getDismissedBundleIds();
    var suggestions = [];
    var seen = {};

    index.bundles.forEach(function (bundle) {
      if (bundle.enabled === false) return;
      if (bundle.type !== 'product_pair') return;
      if (bundle.id && dismissed[bundle.id]) return;
      var pa = bundle.products_a_resolved || bundle.products_a || [];
      var pb = bundle.products_b_resolved || bundle.products_b || [];

      // Customer has A but not B → suggest first B
      var hasAnyA = pa.some(function (h) { return cartHasHandle(cart, h); });
      var hasAnyB = pb.some(function (h) { return cartHasHandle(cart, h); });
      if (hasAnyA && !hasAnyB) {
        var pickHandle = pb[0];
        if (pickHandle && !seen[pickHandle]) {
          seen[pickHandle] = true;
          suggestions.push({ bundle: bundle, handle: pickHandle, side: 'b' });
        }
      } else if (hasAnyB && !hasAnyA) {
        var pickHandleA = pa[0];
        if (pickHandleA && !seen[pickHandleA]) {
          seen[pickHandleA] = true;
          suggestions.push({ bundle: bundle, handle: pickHandleA, side: 'a' });
        }
      }
    });

    if (!suggestions.length) {
      container.setAttribute('hidden', '');
      list.innerHTML = '';
      return;
    }

    Promise.all(suggestions.map(function (s) {
      return fetch('/products/' + encodeURIComponent(s.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? { suggestion: s, product: p } : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var html = '';
      results.forEach(function (r) {
        if (!r) return;
        var b = r.suggestion.bundle;
        var p = r.product;
        var variants = p.variants || [];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var eyebrow = escapeHtml(b.upsell_title || 'Complete the look');
        var savePart;
        if (b.value && b.value.kind === 'percentage') {
          savePart = '<strong>' + b.value.amount + '% off</strong> when bought together';
        } else if (b.value && b.value.kind === 'fixed_amount') {
          savePart = '<strong>$' + b.value.amount + ' off</strong> when bought together';
        } else {
          savePart = '<strong>Bundle deal</strong>';
        }

        var ctaHtml = '';
        if (variants.length > 1) {
          var opts = '<option value="">Add</option>';
          variants.forEach(function (v) {
            opts += '<option value="' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>' +
              escapeHtml(v.title) + (v.available === false ? ' — sold out' : '') + '</option>';
          });
          ctaHtml =
            '<select class="palmr-cd__upsell-cta" data-palmr-cd-upsell-add aria-label="Add ' + escapeHtml(p.title) + ' to cart">' +
            opts + '</select>';
        } else {
          var vid = variants[0] && variants[0].id;
          ctaHtml =
            '<button type="button" class="palmr-cd__upsell-cta" data-palmr-cd-upsell-add data-variant-id="' + vid + '">Add</button>';
        }

        var bundleIdAttr = b.id ? escapeHtml(b.id) : '';
        html +=
          '<li class="palmr-cd__upsell" data-palmr-cd-upsell data-handle="' + escapeHtml(p.handle) + '" data-bundle-id="' + bundleIdAttr + '">' +
          '  <a class="palmr-cd__upsell-image" href="' + escapeHtml(p.url) + '" aria-hidden="true" tabindex="-1" style="background-image:url(\'' + escapeHtml(img) + '\');"></a>' +
          '  <div class="palmr-cd__upsell-body">' +
          '    <p class="palmr-cd__upsell-eyebrow">' + eyebrow + '</p>' +
          '    <a class="palmr-cd__upsell-title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
          '    <p class="palmr-cd__upsell-save">' + savePart + '</p>' +
          '  </div>' +
          '  <div class="palmr-cd__upsell-actions">' +
          '    ' + ctaHtml +
          '    <button type="button" class="palmr-cd__upsell-dismiss" data-palmr-cd-bundle-dismiss="' + bundleIdAttr + '" aria-label="Dismiss this suggestion">No thanks</button>' +
          '  </div>' +
          '</li>';
      });
      list.innerHTML = html;
      if (html) container.removeAttribute('hidden');
      else container.setAttribute('hidden', '');
    });
  }

  // Volume tier progress cards — show one card per active volume bundle the
  // cart has at least one qualifying item from. Card shows: bundle name +
  // savings progress + a row of clickable product thumbnails pulled from the
  // bundle's primary collection so the shopper can browse and add more.
  var volumeCollectionCache = {};
  function fetchCollectionPreview(handle, excludeHandles) {
    if (!handle) return Promise.resolve([]);
    var p = volumeCollectionCache[handle];
    if (!p) {
      p = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=12', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) { return Array.isArray(data.products) ? data.products : []; })
        .catch(function () { return []; });
      volumeCollectionCache[handle] = p;
    }
    return p.then(function (products) {
      var exclude = {};
      (excludeHandles || []).forEach(function (h) { exclude[h] = true; });
      return products
        .filter(function (p) { return p && p.handle && !exclude[p.handle]; })
        .slice(0, 3);
    });
  }

  function loadVolumeBundleProgress(cart) {
    var container = $('[data-palmr-cd-volumes]');
    if (!container) return;
    var list = $('[data-palmr-cd-volumes-list]', container);
    if (!list) return;

    var index = getBundleIndex();
    if (!index || !Array.isArray(index.bundles)) {
      container.setAttribute('hidden', ''); list.innerHTML = ''; return;
    }
    var dismissed = getDismissedBundleIds();
    var inCartHandles = (cart.items || []).map(function (i) { return i.handle; });

    // Build the list of bundles to render (preserves merchant order).
    var renderable = [];
    index.bundles.forEach(function (bundle) {
      if (!bundle || bundle.enabled === false) return;
      if (bundle.type !== 'product_volume') return;
      if (bundle.id && dismissed[bundle.id]) return;

      var products = bundle.products_resolved || bundle.products || [];
      if (!products.length) return;
      var productSet = {};
      products.forEach(function (h) { productSet[h] = true; });

      var qty = 0;
      (cart.items || []).forEach(function (item) {
        if (productSet[item.handle]) qty += (item.quantity || 0);
      });
      if (qty <= 0) return;

      var tiers = (bundle.tiers || []).slice().sort(function (a, b) {
        return (a.min_quantity || 0) - (b.min_quantity || 0);
      });
      if (!tiers.length) return;

      var current = null;
      var next = null;
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= (tiers[i].min_quantity || 0)) current = tiers[i];
        else if (!next) next = tiers[i];
      }
      renderable.push({ bundle: bundle, qty: qty, current: current, next: next });
    });

    if (!renderable.length) {
      container.setAttribute('hidden', ''); list.innerHTML = ''; return;
    }

    // Fetch thumbnails in parallel, then render in merchant order.
    Promise.all(renderable.map(function (entry) {
      var handle = entry.bundle.primary_collection && entry.bundle.primary_collection.handle;
      if (!handle || (entry.current && !entry.next)) return Promise.resolve([]);
      return fetchCollectionPreview(handle, inCartHandles);
    })).then(function (thumbsList) {
      var html = '';
      renderable.forEach(function (entry, idx) {
        html += renderVolumeCard(entry.bundle, entry.qty, entry.current, entry.next, thumbsList[idx] || []);
      });
      list.innerHTML = html;
      if (html) container.removeAttribute('hidden');
      else container.setAttribute('hidden', '');
    });
  }

  function renderVolumeCard(bundle, qty, current, next, thumbs) {
    var displayName = (bundle.display_name && bundle.display_name.trim()) ||
      (bundle.primary_collection && bundle.primary_collection.title) ||
      'this bundle';
    var eyebrow = bundle.upsell_title || 'Bundle Deal';
    var bundleIdAttr = bundle.id ? escapeHtml(bundle.id) : '';
    var collectionHref = bundle.primary_collection && bundle.primary_collection.handle
      ? '/collections/' + encodeURIComponent(bundle.primary_collection.handle)
      : '';

    var headline, sub, pct, maxedClass = '';
    var nextSavings = next && next.savings_label ? next.savings_label : '';
    var currentSavings = current && current.savings_label ? current.savings_label : '';

    if (!current && next) {
      var need = (next.min_quantity || 0) - qty;
      headline = 'Add ' + need + ' more to save <strong>' + escapeHtml(nextSavings || '') + '</strong>';
      sub = qty + ' in cart · ' + (next.min_quantity || 0) + ' unlock' + ((next.min_quantity || 0) === 1 ? 's' : 's') + ' the deal';
      pct = Math.max(5, Math.round((qty / (next.min_quantity || 1)) * 100));
    } else if (current && next) {
      var need2 = (next.min_quantity || 0) - qty;
      headline = '✓ Saving <strong>' + escapeHtml(currentSavings) + '</strong> · Add ' + need2 + ' more for <strong>' + escapeHtml(nextSavings) + '</strong>';
      sub = qty + ' in cart · ' + (next.min_quantity || 0) + ' unlocks the next tier';
      pct = Math.max(50, Math.min(95, Math.round((qty / (next.min_quantity || 1)) * 100)));
    } else {
      headline = '✓ Saving <strong>' + escapeHtml(currentSavings) + '</strong> — top tier unlocked';
      sub = qty + ' in cart';
      pct = 100;
      maxedClass = ' palmr-cd__volume--maxed';
    }

    var thumbsHtml = '';
    if (thumbs && thumbs.length) {
      thumbsHtml += '<div class="palmr-cd__volume-thumbs">';
      thumbs.forEach(function (p) {
        var img = '';
        if (p.images && p.images[0]) {
          img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
        }
        var url = '/products/' + encodeURIComponent(p.handle);
        thumbsHtml +=
          '<a class="palmr-cd__volume-thumb" href="' + url + '" title="' + escapeHtml(p.title || '') + '">' +
          '  <span class="palmr-cd__volume-thumb-img" style="background-image:url(\'' + escapeHtml(img) + '\');"></span>' +
          '  <span class="palmr-cd__volume-thumb-title">' + escapeHtml(p.title || '') + '</span>' +
          '</a>';
      });
      thumbsHtml += '</div>';
    }

    var titleHtml = collectionHref
      ? '<a class="palmr-cd__volume-title" href="' + collectionHref + '">' + escapeHtml(displayName) + ' →</a>'
      : '<p class="palmr-cd__volume-title">' + escapeHtml(displayName) + '</p>';

    return (
      '<li class="palmr-cd__volume' + maxedClass + '" data-palmr-cd-volume data-bundle-id="' + bundleIdAttr + '">' +
      '  <div class="palmr-cd__volume-head">' +
      '    <p class="palmr-cd__volume-eyebrow">' + escapeHtml(eyebrow) + '</p>' +
      '    <button type="button" class="palmr-cd__volume-dismiss" data-palmr-cd-bundle-dismiss="' + bundleIdAttr + '" aria-label="Dismiss this bundle">No thanks</button>' +
      '  </div>' +
      '  ' + titleHtml +
      '  <p class="palmr-cd__volume-headline">' + headline + '</p>' +
      '  <p class="palmr-cd__volume-sub">' + sub + '</p>' +
      '  <div class="palmr-cd__volume-bar"><div class="palmr-cd__volume-fill" style="width:' + pct + '%"></div></div>' +
      '  ' + thumbsHtml +
      '</li>'
    );
  }

  function loadRecommendations() {
    var recs = $('[data-palmr-cd-recs]');
    if (!recs) return;
    var list = $('[data-palmr-cd-recs-list]', recs);
    if (!list) return;
    var intent = recs.getAttribute('data-recs-intent') || 'complementary';
    var limit = parseInt(recs.getAttribute('data-recs-limit'), 10) || 3;

    getCart().then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        recs.setAttribute('hidden', '');
        return;
      }
      updateRecsTitle(cart);
      var pid = cart.items[0].product_id;
      if (pid === recsLoadedForProduct && list.children.length > 0) return;
      recsLoadedForProduct = pid;
      var url = '/recommendations/products.json?product_id=' + pid + '&intent=' + encodeURIComponent(intent) + '&limit=' + limit;
      return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          var inCartIds = cart.items.map(function (i) { return i.product_id; });
          products = products.filter(function (p) { return inCartIds.indexOf(p.id) === -1; }).slice(0, limit);
          if (products.length === 0) {
            recs.setAttribute('hidden', '');
            return;
          }
          list.innerHTML = products.map(renderRec).join('');
          recs.removeAttribute('hidden');
        });
    }).catch(function (err) {
      console.warn('[palmr-cd] recs failed', err);
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderRec(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = p.price_min !== undefined ? p.price_min : (p.price || 0);
    var variants = (p.variants || []).filter(function (v) { return v && v.id; });
    var hasMulti = variants.length > 1;

    var control;
    if (hasMulti) {
      var opts = variants.map(function (v) {
        var label = v.title || v.option1 || 'Variant';
        var avail = v.available !== false;
        return '<option value="' + v.id + '"' + (avail ? '' : ' disabled') + '>' +
               escapeHtml(label) + (avail ? '' : ' — sold out') + '</option>';
      }).join('');
      control =
        '<select class="palmr-cd__rec-select" data-palmr-cd-rec-select aria-label="Choose option for ' + escapeHtml(p.title) + '">' +
        '  <option value="">+ Add</option>' + opts +
        '</select>';
    } else {
      var variantId = variants[0] && variants[0].id;
      control = '<button type="button" class="palmr-cd__rec-add" data-palmr-cd-rec-add data-variant-id="' + variantId + '">+ Add</button>';
    }

    return '' +
      '<li class="palmr-cd__rec">' +
      '  <a class="palmr-cd__rec-image" href="' + escapeHtml(p.url) + '" tabindex="-1" aria-hidden="true">' +
      '    <img src="' + escapeHtml(img) + '&width=300" loading="lazy" alt="" width="110" height="110">' +
      '  </a>' +
      '  <div class="palmr-cd__rec-body">' +
      '    <a class="palmr-cd__rec-title" href="' + escapeHtml(p.url) + '" title="' + escapeHtml(p.title) + '">' + escapeHtml(p.title) + '</a>' +
      '    <div class="palmr-cd__rec-price">' + moneyFormat(price) + '</div>' +
      '  </div>' +
      '  <div class="palmr-cd__rec-control">' + control + '</div>' +
      '</li>';
  }

  function addRecommendedVariant(variantId, control) {
    if (!variantId || isLoading) return;
    var origLabel;
    if (control.tagName === 'BUTTON') {
      origLabel = control.textContent;
      control.disabled = true;
      control.textContent = '…';
    } else if (control.tagName === 'SELECT') {
      control.disabled = true;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function (addedItem) {
        return getCart().then(function (cart) {
          klaviyoTrack('Added to Cart', buildCartPayload(cart, addedItem));
          return refresh();
        });
      })
      .catch(function () {
        if (control.tagName === 'BUTTON') {
          control.disabled = false;
          control.textContent = origLabel || 'Add';
        } else {
          control.disabled = false;
          control.value = '';
        }
      });
  }

  /* ---------- Discount code (cart permalink) ---------- */
  function isCodeApplication(app) {
    if (!app) return false;
    var t = app.type || app.discount_application_type;
    return t === 'discount_code' || t === 'DiscountCodeApplication';
  }

  function findAppliedCode(cart) {
    // Order-level discount codes
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      if (isCodeApplication(apps[i]) && apps[i].title) {
        return { title: apps[i].title, total_allocated_amount: apps[i].total_allocated_amount || 0 };
      }
    }
    // Line-level discount codes (e.g. % off products) — sum allocations across lines
    var lines = (cart && cart.items) || [];
    var byCode = {};
    for (var j = 0; j < lines.length; j++) {
      var allocs = lines[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var alloc = allocs[k];
        var app = alloc.discount_application || {};
        if (isCodeApplication(app) && app.title) {
          byCode[app.title] = (byCode[app.title] || 0) + (alloc.amount || 0);
        }
      }
    }
    var codes = Object.keys(byCode);
    if (codes.length > 0) {
      return { title: codes[0], total_allocated_amount: byCode[codes[0]] };
    }
    return null;
  }

  function removeGiftLines(cart) {
    var updates = {};
    var hasAny = false;
    (cart && cart.items || []).forEach(function (item) {
      if (item.properties && item.properties._gift_tier) {
        updates[item.key] = 0;
        hasAny = true;
      }
    });
    if (!hasAny) return Promise.resolve(cart);
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  function formatMoney(cents) {
    var d = (cents || 0) / 100;
    return '$' + (d === Math.floor(d) ? d.toFixed(0) : d.toFixed(2));
  }

  function updateCheckoutHref(cart) {
    var checkout = $('[data-palmr-cd-checkout]');
    if (!checkout) return;
    var base = checkout.getAttribute('data-base-href');
    if (!base) {
      base = checkout.getAttribute('href') || '/checkout';
      checkout.setAttribute('data-base-href', base);
    }
    var applied = findAppliedCode(cart);
    if (applied) {
      // Code in cart — go straight to checkout, session already has it.
      checkout.setAttribute('href', base);
    } else {
      // No code in cart — force checkout to drop any lingering session discount
      // by routing through /discount/{invalid}. Safe no-op for users without one.
      checkout.setAttribute('href', '/discount/PALMRCLEAR?redirect=' + encodeURIComponent(base));
    }
  }

  function renderDiscountStatus(cart, options) {
    options = options || {};
    var status = $('[data-palmr-cd-discount-status]');
    if (!status) return;
    var applied = findAppliedCode(cart);
    updateCheckoutHref(cart);

    if (applied) {
      status.innerHTML =
        '<span class="palmr-cd__discount-status-row palmr-cd__discount-status-row--ok">' +
        '  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>' +
        '  <strong>' + escapeHtml(applied.title) + '</strong> applied — ' + formatMoney(applied.total_allocated_amount) + ' off' +
        '  <button type="button" class="palmr-cd__discount-remove" data-palmr-cd-discount-remove aria-label="Remove discount code">Remove</button>' +
        '</span>';
      status.setAttribute('data-state', 'ok');
      updateDiscountToolButton(applied.title);
      var inp = $('[data-palmr-cd-discount-form] input[name="code"]');
      if (inp) inp.value = applied.title;
    } else if (options.error) {
      status.innerHTML =
        '<span class="palmr-cd__discount-status-row palmr-cd__discount-status-row--err">' +
        '  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>' +
        '  Code <strong>' + escapeHtml(options.error) + '</strong> is not valid' +
        '</span>';
      status.setAttribute('data-state', 'err');
      updateDiscountToolButton('');
    } else {
      status.innerHTML = '';
      status.removeAttribute('data-state');
      updateDiscountToolButton('');
    }
  }

  function updateDiscountToolButton(code) {
    var btn = $('[data-palmr-cd-tool="discount"]');
    if (!btn) return;
    var label = btn.querySelector('span');
    if (!label) return;
    if (!label.hasAttribute('data-base-label')) {
      label.setAttribute('data-base-label', label.textContent);
    }
    if (code) {
      label.textContent = 'Discount: ' + code + ' ✓';
    } else {
      label.textContent = label.getAttribute('data-base-label') || 'Apply Discount';
    }
  }

  function syncDiscountFromCart() {
    return getCart().then(function (cart) {
      renderDiscountStatus(cart);
    }).catch(function () {});
  }

  function onDiscountSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector('input[name="code"]');
    var raw = (input && input.value || '').trim();
    if (!raw) return;

    setLoading(true);
    // /discount/CODE sets the session discount cookie. ?redirect=/cart.js follows through to the cart JSON.
    fetch('/discount/' + encodeURIComponent(raw) + '?redirect=/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (cart) {
        if (!cart) return getCart();
        return cart;
      })
      .then(function (cart) {
        var applied = findAppliedCode(cart);
        if (applied && applied.title.toLowerCase() === raw.toLowerCase()) {
          // Applied — strip any free-gift lines, then refresh the drawer.
          // Codes can't combine with the gift function discount; gifts stay only when no code applies.
          return removeGiftLines(cart).then(function () { return refresh(); });
        }
        // Code did not apply. Show error.
        renderDiscountStatus(cart, { error: raw });
        setLoading(false);
      })
      .catch(function (err) {
        console.warn('[palmr-cd] discount apply failed', err);
        setLoading(false);
      });
  }

  function onDiscountRemove() {
    setLoading(true);

    // Try multiple cart-clear methods in sequence — Shopify hasn't documented a
    // single canonical AJAX endpoint for clearing a discount code. Each method
    // is best-effort; we run them in order then check if cart.discount_code is empty.
    function tryUpdateDiscount(field) {
      var body = {};
      body[field] = '';
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
        cache: 'no-store'
      }).then(function (r) { return r.json().catch(function () { return null; }); });
    }
    function tryDiscountPermalink(code) {
      return fetch('/discount/' + code + '?redirect=/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store'
      }).then(function (r) { return r.json().catch(function () { return null; }); });
    }

    tryUpdateDiscount('discount')
      .then(function (cart) {
        if (cart && !findAppliedCode(cart)) return cart;
        return tryUpdateDiscount('discount_code');
      })
      .then(function (cart) {
        if (cart && !findAppliedCode(cart)) return cart;
        return tryDiscountPermalink('PALMRCLEAR');
      })
      .catch(function () {})
      .then(function () { return refresh(); })
      .catch(function () { setLoading(false); });
  }

  /* ---------- Shipping estimate ----------
     Auto-pulls the cheapest standard rate from Shopify Admin's configured shipping
     profile (no manual ZIP input). Free at $75+. Caches per-weight per-session to
     avoid re-hitting /cart/shipping_rates.json on every minor cart tick. */
  var SHIPPING_CACHE_KEY = 'palmr_shipping_estimate_v1';
  var SHIPPING_CACHE_TTL_MS = 30 * 60 * 1000;
  var SHIPPING_FREE_THRESHOLD_CENTS = 7500;
  var SHIPPING_DEFAULT_DEST = 'shipping_address[zip]=33701&shipping_address[country]=US&shipping_address[province]=FL';

  function readShippingCache(weight) {
    try {
      var raw = sessionStorage.getItem(SHIPPING_CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || obj.weight !== weight) return null;
      if (Date.now() - obj.t > SHIPPING_CACHE_TTL_MS) return null;
      return obj.cents;
    } catch (e) { return null; }
  }
  function writeShippingCache(weight, cents) {
    try {
      sessionStorage.setItem(SHIPPING_CACHE_KEY, JSON.stringify({
        weight: weight, cents: cents, t: Date.now()
      }));
    } catch (e) {}
  }

  function renderShipping(state, label) {
    var row = $('[data-palmr-cd-shipping]');
    var val = $('[data-palmr-cd-shipping-value]');
    if (!row || !val) return;
    row.setAttribute('data-palmr-cd-shipping-state', state);
    val.removeAttribute('data-loading');
    val.textContent = label;
  }

  // shippingCents: null = unknown ("Calculated at checkout"), 0 = free, >0 = computed
  function renderTotals(cart, shippingCents) {
    var subtotalCents = cart ? (cart.total_price || 0) : 0;
    var originalCents = cart ? (cart.original_total_price || 0) : 0;
    var subEl = $('[data-palmr-cd-subtotal]');
    var savedEl = $('[data-palmr-cd-subtotal-saved]');
    var totEl = $('[data-palmr-cd-total]');
    var hintEl = $('[data-palmr-cd-shipping-hint]');

    if (subEl) subEl.textContent = moneyFormat(subtotalCents);

    if (savedEl) {
      if (originalCents > subtotalCents) {
        savedEl.textContent = ' (you saved ' + moneyFormat(originalCents - subtotalCents) + ')';
      } else {
        savedEl.textContent = '';
      }
    }

    if (hintEl) {
      if (cart && cart.item_count > 0 && subtotalCents < SHIPPING_FREE_THRESHOLD_CENTS) {
        var togo = SHIPPING_FREE_THRESHOLD_CENTS - subtotalCents;
        hintEl.textContent = ' (add ' + moneyFormat(togo) + ' to free shipping)';
      } else {
        hintEl.textContent = '';
      }
    }

    if (totEl) {
      var totalCents = subtotalCents + (shippingCents != null && shippingCents > 0 ? shippingCents : 0);
      totEl.textContent = moneyFormat(totalCents);
    }
  }

  function fetchShippingEstimate(cart) {
    if (!cart || cart.item_count === 0) {
      renderShipping('idle', '');
      renderTotals(cart, null);
      return;
    }
    if (cart.total_price >= SHIPPING_FREE_THRESHOLD_CENTS) {
      renderShipping('free', 'FREE');
      renderTotals(cart, 0);
      return;
    }
    var cached = readShippingCache(cart.total_weight);
    if (cached != null) {
      renderShipping('rate', moneyFormat(cached));
      renderTotals(cart, cached);
      return;
    }
    var val = $('[data-palmr-cd-shipping-value]');
    if (val) {
      val.setAttribute('data-loading', '1');
      val.textContent = 'Calculating…';
    }
    renderTotals(cart, null);
    fetch('/cart/shipping_rates.json?' + SHIPPING_DEFAULT_DEST, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('shipping_rates ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        var standard = rates
          .filter(function (r) { return !/pickup/i.test(r.name || ''); })
          .sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); })[0];
        if (!standard) {
          renderShipping('fallback', 'Calculated at checkout');
          renderTotals(cart, null);
          return;
        }
        var cents = Math.round(parseFloat(standard.price) * 100);
        writeShippingCache(cart.total_weight, cents);
        renderShipping('rate', moneyFormat(cents));
        renderTotals(cart, cents);
      })
      .catch(function () {
        renderShipping('fallback', 'Calculated at checkout');
        renderTotals(cart, null);
      });
  }

  /* ---------- Tool toggles (discount/shipping panels) ---------- */
  function toggleTool(name, btn) {
    var panels = $$('[data-palmr-cd-tool-panel]');
    var btns = $$('[data-palmr-cd-tool]');
    var opening = btn.getAttribute('aria-expanded') !== 'true';
    btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    panels.forEach(function (p) { p.setAttribute('hidden', ''); });
    if (opening) {
      btn.setAttribute('aria-expanded', 'true');
      var panel = $('[data-palmr-cd-tool-panel="' + name + '"]');
      if (panel) panel.removeAttribute('hidden');
    }
  }

  /* ---------- Cart line item handlers (unchanged) ---------- */
  function changeLine(key, quantity) {
    if (isLoading) return Promise.resolve();
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/change failed');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('palmr:cart-drawer:updated'));
        return refresh();
      })
      .catch(function (err) {
        console.warn('[palmr-cd] line change failed', err);
        setLoading(false);
      });
  }

  /* ---------- Click delegation ---------- */
  function onClick(e) {
    var t = e.target;

    var closeTarget = t.closest('[data-palmr-cd-close], [data-palmr-cd-close-on-click]');
    if (closeTarget && root.contains(closeTarget)) {
      if (!closeTarget.matches('[data-palmr-cd-close-on-click]')) e.preventDefault();
      close();
      return;
    }

    var removeBtn = t.closest('[data-palmr-cd-remove]');
    if (removeBtn && root.contains(removeBtn)) {
      e.preventDefault();
      changeLine(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    var qtyBtn = t.closest('[data-palmr-cd-qty]');
    if (qtyBtn && root.contains(qtyBtn)) {
      e.preventDefault();
      var dir = qtyBtn.getAttribute('data-palmr-cd-qty');
      var key = qtyBtn.getAttribute('data-key');
      var input = root.querySelector('[data-palmr-cd-qty-input][data-key="' + key + '"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = dir === 'inc' ? current + 1 : Math.max(0, current - 1);
      changeLine(key, next);
      return;
    }

    var toolBtn = t.closest('[data-palmr-cd-tool]');
    if (toolBtn && root.contains(toolBtn)) {
      e.preventDefault();
      toggleTool(toolBtn.getAttribute('data-palmr-cd-tool'), toolBtn);
      return;
    }

    var recAddBtn = t.closest('[data-palmr-cd-rec-add]');
    if (recAddBtn && root.contains(recAddBtn)) {
      e.preventDefault();
      addRecommendedVariant(recAddBtn.getAttribute('data-variant-id'), recAddBtn);
      return;
    }

    var upsellAddBtn = t.closest('button[data-palmr-cd-upsell-add]');
    if (upsellAddBtn && root.contains(upsellAddBtn)) {
      e.preventDefault();
      addRecommendedVariant(upsellAddBtn.getAttribute('data-variant-id'), upsellAddBtn);
      return;
    }

    var upsellDismissBtn = t.closest('[data-palmr-cd-bundle-dismiss]');
    if (upsellDismissBtn && root.contains(upsellDismissBtn)) {
      e.preventDefault(); e.stopPropagation();
      var bundleId = upsellDismissBtn.getAttribute('data-palmr-cd-bundle-dismiss');
      setBundleDismissed(bundleId);
      var tile = upsellDismissBtn.closest('[data-palmr-cd-upsell], [data-palmr-cd-volume]');
      if (tile && tile.parentNode) tile.parentNode.removeChild(tile);
      var upsellContainer = $('[data-palmr-cd-upsells]');
      if (upsellContainer) {
        var remainingU = upsellContainer.querySelectorAll('[data-palmr-cd-upsell]');
        if (!remainingU.length) upsellContainer.setAttribute('hidden', '');
      }
      var volumeContainer = $('[data-palmr-cd-volumes]');
      if (volumeContainer) {
        var remainingV = volumeContainer.querySelectorAll('[data-palmr-cd-volume]');
        if (!remainingV.length) volumeContainer.setAttribute('hidden', '');
      }
      return;
    }

    var discountRemoveBtn = t.closest('[data-palmr-cd-discount-remove]');
    if (discountRemoveBtn && root.contains(discountRemoveBtn)) {
      e.preventDefault();
      var input = $('[data-palmr-cd-discount-form] input[name="code"]');
      if (input) input.value = '';
      onDiscountRemove();
      return;
    }

    var giftPickBtn = t.closest('button[data-palmr-cd-gift-pick]');
    if (giftPickBtn && root.contains(giftPickBtn)) {
      e.preventDefault();
      pickGift(giftPickBtn.getAttribute('data-tier'), giftPickBtn.getAttribute('data-variant-id'));
      return;
    }

    var giftDismissBtn = t.closest('[data-palmr-cd-gift-dismiss]');
    if (giftDismissBtn && root.contains(giftDismissBtn)) {
      e.preventDefault(); e.stopPropagation();
      var dismissTier = giftDismissBtn.getAttribute('data-palmr-cd-gift-dismiss');
      setGiftDismissed(dismissTier, true);
      var dPicker = $('[data-palmr-cd-gift-picker="' + dismissTier + '"]');
      if (dPicker) dPicker.classList.add('is-collapsed');
      return;
    }

    var collapsedPicker = t.closest('.palmr-cd__gift-picker.is-collapsed');
    if (collapsedPicker && root.contains(collapsedPicker)) {
      e.preventDefault();
      var expandTier = collapsedPicker.getAttribute('data-tier');
      setGiftDismissed(expandTier, false);
      collapsedPicker.classList.remove('is-collapsed');
      return;
    }
  }

  var qtyInputTimers = {};
  function onChange(e) {
    var t = e.target;
    if (!root.contains(t)) return;

    var recSelect = t.closest('[data-palmr-cd-rec-select]');
    if (recSelect) {
      var variantId = recSelect.value;
      if (variantId) addRecommendedVariant(variantId, recSelect);
      return;
    }

    var upsellSelect = t.closest('select[data-palmr-cd-upsell-add]');
    if (upsellSelect) {
      var upsellVariantId = upsellSelect.value;
      if (upsellVariantId) {
        addRecommendedVariant(upsellVariantId, upsellSelect);
        upsellSelect.value = '';
      }
      return;
    }

    var giftSelect = t.closest('select[data-palmr-cd-gift-pick]');
    if (giftSelect) {
      var giftVariantId = giftSelect.value;
      if (giftVariantId) {
        giftSelect.disabled = true;
        pickGift(giftSelect.getAttribute('data-tier'), giftVariantId);
      }
      return;
    }

    var qtyInput = t.closest('[data-palmr-cd-qty-input]');
    if (qtyInput) {
      var key = qtyInput.getAttribute('data-key');
      clearTimeout(qtyInputTimers[key]);
      qtyInputTimers[key] = setTimeout(function () {
        var q = Math.max(0, parseInt(qtyInput.value, 10) || 0);
        changeLine(key, q);
      }, 350);
    }
  }

  function onSubmit(e) {
    var t = e.target;
    if (!root.contains(t)) return;
    if (t.matches('[data-palmr-cd-discount-form]')) onDiscountSubmit(e);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      e.preventDefault();
      close();
    }
  }

  document.addEventListener('cart-drawer:open', open);
  document.addEventListener('on:cart:add', function () { refresh().then(open); });

  root.addEventListener('click', onClick);
  root.addEventListener('input', onChange);
  root.addEventListener('change', onChange);
  root.addEventListener('submit', onSubmit);
  document.addEventListener('keydown', onKeydown);

  updateRewardBar();
  getCart().then(function (cart) {
    renderDiscountStatus(cart);
    updateGiftPickers(cart);
    fetchShippingEstimate(cart);
  }).catch(function () {});

  window.PalmrCartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
